// src/modules/profile/hooks/useThemeUpdater.ts
import { useCallback } from "react";
import { Theme } from "../types/profile";
import { applyTheme } from "../utils/themeUtils";
import { updateThemeApi } from "../../../services/themeService";

export const useThemeUpdater = (
  setTheme: (theme: Theme) => void,
  setStoredColor: (themes: Theme[]) => void
) => {
  const updateTheme = useCallback(
    async (newTheme: Theme) => {
      try {
        await updateThemeApi(newTheme);

        // Update React state
        setTheme(newTheme);
        setStoredColor([newTheme]);

        // Apply immediately
        applyTheme(newTheme);

        return { success: true };
      } catch (error) {
        console.error("Error updating theme:", error);
        return { success: false, error };
      }
    },
    [setTheme, setStoredColor]
  );

  return { updateTheme };
};
